<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.downloads'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
      :widthSearch="false"
    />
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="downloadTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="createAt"
          :label="$t('text.createAt')"
          width="180"
        />
        <vxe-table-column
          field="state"
          :title="$t('text.workflowState')"
          width="160"
        >
          <template v-slot="{ row }">
            <i class="el-icon-loading" v-if="row.state == 'downloading'"></i>
            <span v-else>{{ $t("downloadFileStates." + row.state) }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="downloadAt"
          :title="$t('download.downloadAt')"
          width="180"
        />
        <vxe-table-column field="remark" :title="$t('text.remark')" />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="50"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="row.state == 'finish'"
              type="text"
              size="mini"
              @click="download(row)"
              >{{ $t("action.download") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qrcode from "@chenfengyuan/vue-qrcode";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DownloadFile from "@/api/downloadFile.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.sorter,
    table.basic,
  ],
  components: { Qrcode },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("download.downloadInfo"),
            items: [
              {
                label: this.$t("download.downloaded"),
                key: "yes",
                condition: { download: "yes" },
              },
              {
                label: this.$t("download.unDownload"),
                key: "no",
                condition: { download: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      // sorter: {
      //   sortBy: "downloadFiles_id",
      //   sortIndicator: "desc",
      // },
      Util: Util,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    download(row) {
      const self = this;
      DownloadFile.download(row.id).then(function (res) {
        if (res.status === 200) {
          window.open(row.fileLink);
          self.$message({
            message: self.$t("prompt.downloadSuccess"),
            type: "success",
          });
          self.loadData();
          self.waitingDownloadCount();
        } else {
          self.sysError();
        }
      });
    },
    waitingDownloadCount() {
      const self = this;
      DownloadFile.waitingDownloadCount().then(function (res) {
        if (res.status == 200) {
          if (res.data == 0) {
            self.$eventHub.$emit("downloadFileDownloadFinish");
          }
        } else {
          self.sysError();
        }
      });
    },
    //
    dataProvider(params) {
      return DownloadFile.search(params);
    },
  },
};
</script>
<style scoped>
</style>